import { routes } from "@constants/routes";
import { CanadaVisaStatus, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { useGetCanadaVisaQuery } from "@graphql/generated";
import { useParams } from "react-router-dom";

const CanadaVisaStatusTabContent = () => {
  const params = useParams();
  const { data, loading } = useGetCanadaVisaQuery({ variables: { id: params.id } });

  return (
    <div>
      <CanadaVisaStatus
        canadaVisaData={data?.admin?.jobSeekers?.edges?.[0]?.node?.canadaVisa}
        loading={loading}
        supportUrl={routes.support.main}
        userType={UserTypeEnum.ADMIN}
      />
    </div>
  );
};

export default CanadaVisaStatusTabContent;
